module.exports = __webpack_public_path__ + "img/student-icon.d9cac637.svg";